export const SET_SOURCE_FEED_MANUAL_PRICE = 'SET_SOURCE_FEED_MANUAL_PRICE';
export const SET_TOMEI_PRICE_MANUAL_PRICE = 'SET_TOMEI_PRICE_MANUAL_PRICE';
export const SET_CUT_OFF = 'SET_CUT_OFF';
export const GET_FEED_MANUAL_PRICE_HISTORY = 'GET_FEED_MANUAL_PRICE_HISTORY';
export const SET_FEED_MANUAL_PRICE_HISTORY = 'SET_FEED_MANUAL_PRICE_HISTORY';
export const GET_FEED_CUT_OFF_HISTORY = 'GET_FEED_CUT_OFF_HISTORY';
export const SET_FEED_CUT_OFF_HISTORY = 'SET_FEED_CUT_OFF_HISTORY';
export const SET_TOMEI_PRICE_ADJUSTMENT = 'SET_TOMEI_PRICE_ADJUSTMENT';
